// extracted by mini-css-extract-plugin
export var card = "_ku-5";
export var cardSelected = "_ku-4";
export var image = "_ku-3";
export var modal = "_ku-0";
export var modalContent = "_ku-1";
export var table = "_ku-2";